// src/Header.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const Header = () => {
  const navigate = useNavigate();
  const { user, profile } = useAuth();

  const handleDashboard = () => {
    if (!profile) { window.open('/quote-dashboard', '_blank'); return; }
    const dest = profile.role === 'manager' ? '/manager-dashboard' : '/quote-dashboard';
    window.open(dest, '_blank');
  };

  return (
    <header className="header flex justify-between items-center" style={{ position: 'relative' }}>
      <div className="flex flex-col items-start" style={{ cursor: 'pointer' }} onClick={() => window.location.href='/client-info'}>
        <h1 className="text-3xl font-bold">
          SolarQuotePro<sup style={{ fontSize: '12px', opacity: 0.45, fontWeight: 400, verticalAlign: 'super' }}>™</sup>
        </h1>
        <p className="text-sm italic mt-0" style={{ opacity: 0.75 }}>
          Transformez vos devis solaires en expériences !
        </p>
      </div>

      {/* Boutons droite */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>

        {/* Tableau de bord */}
        {user && (
          <button onClick={handleDashboard}
            onMouseEnter={e => { e.currentTarget.style.background='rgba(255,255,255,0.22)'; e.currentTarget.style.borderColor='rgba(255,255,255,0.55)'; }}
            onMouseLeave={e => { e.currentTarget.style.background='rgba(255,255,255,0.10)'; e.currentTarget.style.borderColor='rgba(255,255,255,0.30)'; }}
            style={{
              background: 'rgba(255,255,255,0.10)',
              border: '1px solid rgba(255,255,255,0.30)',
              color: 'white', borderRadius: '8px', padding: '7px 14px',
              cursor: 'pointer', fontSize: '13px', fontWeight: 500,
              transition: 'all 0.18s ease',
              display: 'inline-flex', alignItems: 'center', gap: '6px',
            }}>
            📋 Tableau de bord
          </button>
        )}

        {/* Changer mot de passe */}
        {user && (
          <button onClick={() => navigate('/change-password')}
            onMouseEnter={e => { e.currentTarget.style.background='rgba(255,255,255,0.22)'; e.currentTarget.style.borderColor='rgba(255,255,255,0.55)'; }}
            onMouseLeave={e => { e.currentTarget.style.background='rgba(255,255,255,0.10)'; e.currentTarget.style.borderColor='rgba(255,255,255,0.30)'; }}
            style={{
              background: 'rgba(255,255,255,0.10)',
              border: '1px solid rgba(255,255,255,0.30)',
              color: 'white', borderRadius: '8px', padding: '7px 12px',
              cursor: 'pointer', fontSize: '13px', fontWeight: 500,
              transition: 'all 0.18s ease',
              display: 'inline-flex', alignItems: 'center', gap: '5px',
            }}
            title="Changer mon mot de passe">
            🔒
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;
